import { authFetch } from '../auth/authFetch';
import type { components } from './schema.gen';

// Wire types come from the backend's OpenAPI schema — regenerate with
// `npm run gen:api`. Do not hand-edit schema.gen.ts.
export type AnalyticsSummary = components['schemas']['AnalyticsSummary'];
export type Totals = components['schemas']['Totals'];
export type TrendPoint = components['schemas']['TrendPoint'];
export type TopArticle = components['schemas']['TopArticle'];
export type Funnel = components['schemas']['Funnel'];

export type Range = '7d' | '30d' | '90d';

export async function fetchSummary(range: Range): Promise<AnalyticsSummary> {
  const res = await authFetch(`/clients/new_dawn/admin/analytics/summary?range=${range}`);
  if (!res.ok) throw new Error(`Analytics request failed: ${res.status}`);
  return res.json();
}
